<p-dialog
  header="Quote Item Details"
  [modal]="true"
  [(visible)]="visible"
  [style]="{ width: '90vw', height: '90vh' }"
  appendTo="body"
  (onShow)="onDialogShow()"
  (onHide)="closeDialog()"
>
  @if (contentMode === "drawing") {
    <app-quote-revision-item-drawing-information
      [item]="item"
      [visible]="visible"
      [currencyCode]="currencyCode"
      [activePanel]="activePanel"
      [tradeStudyToolFeaturesEnabled]="tradeStudyToolFeaturesEnabled"
      [consumablesEnabled]="consumablesEnabled"
      [readOnly]="readOnly"
      (relinkCadRequested)="onRelinkCadRequested()"
    />
  } @else {
    <div class="flex gap-4" style="height: calc(90vh - 120px)">
      <div class="flex w-[40%] flex-col gap-4" style="min-height: 0">
        @if (contentMode === "cad") {
          <div class="h-1/2">
            <app-cad-viewer
              [cadObjects]="loadedCadObjects"
              [visibleCadObjectIds]="visibleCadObjectIds"
              [externallyHoveredCadObjectId]="hoveredCadObjectId"
              (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
              [dfmCheck]="selectedDFMCheck"
            />
          </div>
          <p-divider />
          <div class="flex h-1/2 flex-col gap-2" style="min-height: 0">
            <app-cad-object-tree
              class="block min-h-0 flex-1"
              [cadObjects]="loadedCadObjects"
              [selectable]="true"
              [selectedCadObjectId]="selectedCadObject?.id ?? null"
              (selectedCadObjectChange)="onSelectedCadObjectChange($event)"
              [hoveredCadObjectId]="hoveredCadObjectId"
              (hoveredCadObjectIdChange)="hoveredCadObjectId = $event"
              (visibleCadObjectIdsChange)="visibleCadObjectIds = $event"
            />
            @if (!readOnly) {
              <p-button
                label="Relink CAD"
                icon="pi pi-link"
                severity="secondary"
                styleClass="w-full"
                (onClick)="onRelinkCadRequested()"
              />
            }
          </div>
        } @else {
          <div
            class="flex h-full flex-col items-center justify-center gap-3 px-6"
          >
            <p class="text-center text-sm text-surface-switch-600">
              No CAD is currently linked to this item.
            </p>
            @if (!readOnly) {
              <p-button
                label="Link CAD"
                icon="pi pi-link"
                (onClick)="onRelinkCadRequested()"
              />
            }
          </div>
        }
      </div>
      <p-divider layout="vertical" />
      <div class="flex w-[60%] flex-col overflow-y-auto" style="min-height: 0">
        <p-tabs [value]="detailsTab" (valueChange)="activePanel = $any($event)">
          <p-tablist>
            <p-tab value="details">Item Details</p-tab>
            @if (contentMode === "cad") {
              <p-tab value="properties">CAD Properties</p-tab>
              <p-tab value="dfm">DFM Checks</p-tab>
              <p-tab value="pricing">Pricing Information</p-tab>
            }
            @if (tradeStudyToolFeaturesEnabled) {
              <p-tab value="capex">CapEx</p-tab>
            }
            @if (showConsumablesTab) {
              <p-tab value="consumables">Consumables</p-tab>
            }
          </p-tablist>
          <p-tabpanels>
            <p-tabpanel value="details"
              ><app-quote-revision-item-details-panel
                [item]="item"
                [currencyCode]="currencyCode"
            /></p-tabpanel>
            @if (contentMode === "cad") {
              <p-tabpanel value="properties">
                @if (selectedCadObject) {
                  <app-cad-properties [cadObject]="selectedCadObject" />
                }
              </p-tabpanel>
              <p-tabpanel value="dfm"
                ><app-quote-revision-item-dfm-checks
                  [item]="item"
                  [selectedCadObjectId]="selectedCadObject?.id ?? null"
                  [selectedDFMCheck]="selectedDFMCheck"
                  (selectedDFMCheckChange)="onSelectedDFMCheckChange($event)"
              /></p-tabpanel>
              <p-tabpanel value="pricing"
                ><app-quote-revision-item-pricing-information
                  [item]="item"
                  [currencyCode]="currencyCode"
                  [selectedCadObjectId]="
                    selectedCadObject?.id?.toString() ?? null
                  "
              /></p-tabpanel>
            }
            @if (tradeStudyToolFeaturesEnabled) {
              <p-tabpanel value="capex"
                ><app-quote-revision-item-capex-information
                  [item]="item"
                  [currencyCode]="currencyCode"
                  [readOnly]="readOnly"
              /></p-tabpanel>
            }
            @if (showConsumablesTab) {
              <p-tabpanel value="consumables"
                ><app-quote-revision-item-consumables-information
                  [item]="item"
                  [currencyCode]="currencyCode"
                  [readOnly]="readOnly"
              /></p-tabpanel>
            }
          </p-tabpanels>
        </p-tabs>
      </div>
    </div>
  }
</p-dialog>

@if (relinkCadVisible) {
  <app-quote-item-link-cad
    [initialLinkItems]="relinkLinkItems"
    mode="item"
    (confirmed)="onRelinkCadConfirmed($event)"
    (closed)="onRelinkCadClosed()"
  />
}
